/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetToolsetEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetToolsetEnvironmentRequest = {
  /**
   * The ID of the toolset
   */
  toolsetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetToolsetEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetToolsetEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  GetToolsetEnvironmentSecurity$Outbound,
  GetToolsetEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolsetEnvironmentSecurityToJSON(
  getToolsetEnvironmentSecurity: GetToolsetEnvironmentSecurity,
): string {
  return JSON.stringify(
    GetToolsetEnvironmentSecurity$outboundSchema.parse(
      getToolsetEnvironmentSecurity,
    ),
  );
}

/** @internal */
export type GetToolsetEnvironmentRequest$Outbound = {
  toolset_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetToolsetEnvironmentRequest$outboundSchema: z.ZodMiniType<
  GetToolsetEnvironmentRequest$Outbound,
  GetToolsetEnvironmentRequest
> = z.pipe(
  z.object({
    toolsetId: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolsetId: "toolset_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getToolsetEnvironmentRequestToJSON(
  getToolsetEnvironmentRequest: GetToolsetEnvironmentRequest,
): string {
  return JSON.stringify(
    GetToolsetEnvironmentRequest$outboundSchema.parse(
      getToolsetEnvironmentRequest,
    ),
  );
}
